// Mock data for initial frontend development
// This will be replaced with real data from backend APIs

export const mockProjects = [
  {
    id: 1,
    name: "AI-Powered-Chatbot",
    description: "An intelligent chatbot using LangChain and GPT-4 for natural language understanding and context-aware responses.",
    html_url: "https://github.com/PB811/AI-Powered-Chatbot",
    stargazers_count: 45,
    language: "Python",
    topics: ["langchain", "gpt-4", "ai", "chatbot"],
    updated_at: "2024-12-15T10:30:00Z"
  },
  {
    id: 2,
    name: "RAG-System",
    description: "Retrieval Augmented Generation system using LlamaIndex for document question-answering with vector embeddings.",
    html_url: "https://github.com/PB811/RAG-System",
    stargazers_count: 38,
    language: "Python",
    topics: ["rag", "llamaindex", "embeddings", "ml"],
    updated_at: "2024-11-20T14:22:00Z"
  },
  {
    id: 3,
    name: "Agentic-Workflow",
    description: "Multi-agent system built with LangGraph for complex task automation and orchestration.",
    html_url: "https://github.com/PB811/Agentic-Workflow",
    stargazers_count: 52,
    language: "Python",
    topics: ["langgraph", "agents", "automation", "ai"],
    updated_at: "2024-12-01T09:15:00Z"
  },
  {
    id: 4,
    name: "ML-Pipeline-Rust",
    description: "High-performance machine learning pipeline written in Rust for data preprocessing and model inference.",
    html_url: "https://github.com/PB811/ML-Pipeline-Rust",
    stargazers_count: 29,
    language: "Rust",
    topics: ["rust", "ml", "performance", "pipeline"],
    updated_at: "2024-10-28T16:45:00Z"
  },
  {
    id: 5,
    name: "MCP-Integration",
    description: "Model Context Protocol implementation for seamless AI model integration and context management.",
    html_url: "https://github.com/PB811/MCP-Integration",
    stargazers_count: 31,
    language: "Python",
    topics: ["mcp", "ai", "integration", "context"],
    updated_at: "2024-11-10T11:30:00Z"
  },
  {
    id: 6,
    name: "Vector-DB-Experiments",
    description: "Experiments with various vector databases for semantic search and similarity matching.",
    html_url: "https://github.com/PB811/Vector-DB-Experiments",
    stargazers_count: 22,
    language: "Python",
    topics: ["vector-db", "embeddings", "search", "ml"],
    updated_at: "2024-09-15T13:20:00Z"
  }
];

export const mockSkills = [
  { name: "Python", category: "language" },
  { name: "Rust", category: "language" },
  { name: "LangChain", category: "framework" },
  { name: "LangGraph", category: "framework" },
  { name: "LlamaIndex", category: "framework" },
  { name: "RAG", category: "technique" },
  { name: "MCP", category: "protocol" },
  { name: "Machine Learning", category: "domain" },
  { name: "AI Agents", category: "domain" },
  { name: "Vector Databases", category: "technology" },
  { name: "FastAPI", category: "framework" },
  { name: "React", category: "framework" }
];

export const mockExperience = [
  {
    id: 1,
    title: "AI/ML Software Engineer",
    company: "Current Company",
    period: "2024 - Present",
    description: "Working on cutting-edge AI/ML solutions using agentic frameworks and building production-ready systems.",
    current: true
  },
  {
    id: 2,
    title: "Computer Science Graduate",
    company: "BITS Pilani",
    period: "2020 - 2024",
    description: "Graduated with a degree in Computer Science, focusing on AI/ML and software engineering.",
    current: false
  }
];